import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAtomValue } from "jotai";
import { PROFILE_ATOM } from "@/context";
import { identifyOpenAIUser, openAIContent, trackOpenAI } from "@/utils/openaiPixel";

// App-wide OpenAI pixel wiring: a page_viewed per SPA route change (the pixel
// doesn't track history changes itself) and hashed user data once the profile
// is known.
export const useOpenAIPixel = () => {
    const { pathname } = useLocation();
    const profile = useAtomValue(PROFILE_ATOM);

    useEffect(() => {
        trackOpenAI("page_viewed", {
            contents: [openAIContent({ id: pathname, contentType: "page" })],
        });
    }, [pathname]);

    useEffect(() => {
        if (!profile?.email) return;
        identifyOpenAIUser(profile);
    }, [profile?.email, profile?.first_name, profile?.last_name]);
};
